/* tslint:disable */
/* eslint-disable */
/**
 * Mild Blue s.r.o. - Online Connect
 * Application allowing people to ask for admition in IKEM.
 *
 * The version of the OpenAPI document: development
 * Contact: support@mild.blue
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { EmailWithPhoneNumberDtoIn } from '../model';
// @ts-ignore
import { FormAccessRightsDtoOut } from '../model';
// @ts-ignore
import { OkResponse } from '../model';
// @ts-ignore
import { OtpDtoIn } from '../model';
// @ts-ignore
import { PhoneNumberDto } from '../model';
/**
 * EnrollmentApi - axios parameter creator
 * @export
 */
export const EnrollmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Creates new registration request for doctor.
         * @param {string} [captcha] Token from the Google Captcha.
         * @param {PhoneNumberDto} [phoneNumberDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnrollDoctorPost: async (captcha?: string, phoneNumberDto?: PhoneNumberDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/enroll/doctor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (captcha !== undefined) {
                localVarQueryParameter['captcha'] = captcha;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(phoneNumberDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates new registration request for patient.
         * @param {string} [captcha] Token from the Google Captcha.
         * @param {PhoneNumberDto} [phoneNumberDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnrollPatientPost: async (captcha?: string, phoneNumberDto?: PhoneNumberDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/enroll/patient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (captcha !== undefined) {
                localVarQueryParameter['captcha'] = captcha;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(phoneNumberDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates new registration request for receipt order.
         * @param {string} [captcha] Token from the Google Captcha.
         * @param {EmailWithPhoneNumberDtoIn} [emailWithPhoneNumberDtoIn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnrollReceiptPost: async (captcha?: string, emailWithPhoneNumberDtoIn?: EmailWithPhoneNumberDtoIn, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/enroll/receipt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (captcha !== undefined) {
                localVarQueryParameter['captcha'] = captcha;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailWithPhoneNumberDtoIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verifies that the registration was successful and issues an authorization cookie.
         * @param {OtpDtoIn} [otpDtoIn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnrollVerifyPost: async (otpDtoIn?: OtpDtoIn, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/enroll/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(otpDtoIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnrollmentApi - functional programming interface
 * @export
 */
export const EnrollmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EnrollmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Creates new registration request for doctor.
         * @param {string} [captcha] Token from the Google Captcha.
         * @param {PhoneNumberDto} [phoneNumberDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnrollDoctorPost(captcha?: string, phoneNumberDto?: PhoneNumberDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnrollDoctorPost(captcha, phoneNumberDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates new registration request for patient.
         * @param {string} [captcha] Token from the Google Captcha.
         * @param {PhoneNumberDto} [phoneNumberDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnrollPatientPost(captcha?: string, phoneNumberDto?: PhoneNumberDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnrollPatientPost(captcha, phoneNumberDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates new registration request for receipt order.
         * @param {string} [captcha] Token from the Google Captcha.
         * @param {EmailWithPhoneNumberDtoIn} [emailWithPhoneNumberDtoIn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnrollReceiptPost(captcha?: string, emailWithPhoneNumberDtoIn?: EmailWithPhoneNumberDtoIn, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnrollReceiptPost(captcha, emailWithPhoneNumberDtoIn, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Verifies that the registration was successful and issues an authorization cookie.
         * @param {OtpDtoIn} [otpDtoIn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnrollVerifyPost(otpDtoIn?: OtpDtoIn, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormAccessRightsDtoOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnrollVerifyPost(otpDtoIn, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EnrollmentApi - factory interface
 * @export
 */
export const EnrollmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EnrollmentApiFp(configuration)
    return {
        /**
         * 
         * @summary Creates new registration request for doctor.
         * @param {string} [captcha] Token from the Google Captcha.
         * @param {PhoneNumberDto} [phoneNumberDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnrollDoctorPost(captcha?: string, phoneNumberDto?: PhoneNumberDto, options?: any): AxiosPromise<OkResponse> {
            return localVarFp.apiEnrollDoctorPost(captcha, phoneNumberDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates new registration request for patient.
         * @param {string} [captcha] Token from the Google Captcha.
         * @param {PhoneNumberDto} [phoneNumberDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnrollPatientPost(captcha?: string, phoneNumberDto?: PhoneNumberDto, options?: any): AxiosPromise<OkResponse> {
            return localVarFp.apiEnrollPatientPost(captcha, phoneNumberDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates new registration request for receipt order.
         * @param {string} [captcha] Token from the Google Captcha.
         * @param {EmailWithPhoneNumberDtoIn} [emailWithPhoneNumberDtoIn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnrollReceiptPost(captcha?: string, emailWithPhoneNumberDtoIn?: EmailWithPhoneNumberDtoIn, options?: any): AxiosPromise<OkResponse> {
            return localVarFp.apiEnrollReceiptPost(captcha, emailWithPhoneNumberDtoIn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verifies that the registration was successful and issues an authorization cookie.
         * @param {OtpDtoIn} [otpDtoIn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnrollVerifyPost(otpDtoIn?: OtpDtoIn, options?: any): AxiosPromise<FormAccessRightsDtoOut> {
            return localVarFp.apiEnrollVerifyPost(otpDtoIn, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnrollmentApi - object-oriented interface
 * @export
 * @class EnrollmentApi
 * @extends {BaseAPI}
 */
export class EnrollmentApi extends BaseAPI {
    /**
     * 
     * @summary Creates new registration request for doctor.
     * @param {string} [captcha] Token from the Google Captcha.
     * @param {PhoneNumberDto} [phoneNumberDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentApi
     */
    public apiEnrollDoctorPost(captcha?: string, phoneNumberDto?: PhoneNumberDto, options?: any) {
        return EnrollmentApiFp(this.configuration).apiEnrollDoctorPost(captcha, phoneNumberDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates new registration request for patient.
     * @param {string} [captcha] Token from the Google Captcha.
     * @param {PhoneNumberDto} [phoneNumberDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentApi
     */
    public apiEnrollPatientPost(captcha?: string, phoneNumberDto?: PhoneNumberDto, options?: any) {
        return EnrollmentApiFp(this.configuration).apiEnrollPatientPost(captcha, phoneNumberDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates new registration request for receipt order.
     * @param {string} [captcha] Token from the Google Captcha.
     * @param {EmailWithPhoneNumberDtoIn} [emailWithPhoneNumberDtoIn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentApi
     */
    public apiEnrollReceiptPost(captcha?: string, emailWithPhoneNumberDtoIn?: EmailWithPhoneNumberDtoIn, options?: any) {
        return EnrollmentApiFp(this.configuration).apiEnrollReceiptPost(captcha, emailWithPhoneNumberDtoIn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verifies that the registration was successful and issues an authorization cookie.
     * @param {OtpDtoIn} [otpDtoIn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentApi
     */
    public apiEnrollVerifyPost(otpDtoIn?: OtpDtoIn, options?: any) {
        return EnrollmentApiFp(this.configuration).apiEnrollVerifyPost(otpDtoIn, options).then((request) => request(this.axios, this.basePath));
    }
}
